import React from "react";


function YoelloBanner() {
    return <div>
        <div style={{
            textAlign: 'center'
        }}>
            <img src={require("../../imges/yoello logo.svg")} alt="Yoello" />
        </div>
    </div>
}

export default YoelloBanner;